<template>
  <refonte-details-header
    title="25 Clés pour une application dynamique des NEP"
    reference="Référence 120928"
    other_reference="Référence produit 124"
    v-bind:on_click_fiche_programme="() => console.log('Fiche Programme')"
    v-bind:session="{}">
    <template v-slot:tags>
      <refonte-tag variant="presentiel"> Présentiel </refonte-tag>
    </template>
    <template v-slot:accessibility>
      <IconLunch />
      <IconLunch />
      <IconLunch />
      <IconLunch />
      <IconLunch />
    </template>
  </refonte-details-header>
  <refonte-collapse
    class="mt-[12px]"
    v-bind:title_icon="IconParticipants"
    title="Participants">
    <template v-slot:headerSumUp>
      <refonte-details-header-item
        v-bind:icon_left="IconValidate"
        text="7/7 inscrits" />
      <refonte-details-header-item
        v-bind:icon_left="IconValidate"
        text="Tests de positionnement" />
      <refonte-details-header-item text="5/7 Conventions individuelles" />
      <refonte-details-header-item
        v-bind:icon_left="IconValidate"
        text="Certificats" />
      <refonte-details-header-item
        v-bind:icon_left="IconValidate"
        text="Évaluation" />
    </template>
    Contenu
  </refonte-collapse>
  <refonte-collapse
    class="mt-[12px]"
    title="Devenir CAC of the Year 2024">
    <template v-slot:headerTags>
      <refonte-tag v-bind:icon="IconFlagParcours">
        <refonte-number variant="count">5</refonte-number>
      </refonte-tag>
      <refonte-tag variant="cursus"> Cursus </refonte-tag>
    </template>
    Contenu
  </refonte-collapse>
</template>

<script setup lang="ts">
  import IconFlagParcours from '@/assets/img/refonte/icons/information/icon-flag-parcours.svg?component';
  import IconLunch from '@/assets/img/refonte/icons/information/icon-lunch.svg?component';
  import IconValidate from '@/assets/img/refonte/icons/information/icon-validate.svg?component';
  import IconParticipants from '@/assets/img/refonte/icons/menu/icon-trainees.svg?component';
  import RefonteTag from '@/components/refonte/tags/refonte-tag.vue';
  import RefonteNumber from '@/components/refonte/numbers/refonte-number.vue';
  import RefonteDetailsHeader from '@/components/refonte/details/refonte-details-header.vue';
  import RefonteDetailsHeaderItem from '@/components/refonte/details/refonte-details-header-item.vue';
  import RefonteCollapse from '@/components/refonte/collapse/refonte-collapse.vue';
</script>

<style lang="scss" scoped></style>
